import { isNumeric } from 'application/util/number.util';

export const BALANCE_OVERRIDE_COLOR_DESTRUCTIVE = 'var(--color-danger)';
export const BALANCE_OVERRIDE_COLOR_WARNING = 'var(--color-warning, #f2b01e)';

export function getBalanceOverrideColor(value, threshold) {
    const normalizedValue = isNumeric(value) ? Number(value) : 0;
    const normalizedThreshold = isNumeric(threshold) ? Number(threshold) : null;
    const hasPositiveThreshold = normalizedThreshold != null && normalizedThreshold > 0;

    if (normalizedValue < 0) {
        return BALANCE_OVERRIDE_COLOR_DESTRUCTIVE;
    }

    if (hasPositiveThreshold && normalizedValue < normalizedThreshold) {
        return BALANCE_OVERRIDE_COLOR_WARNING;
    }

    return null;
}




// WEBPACK FOOTER //
// ./src/application/util/balance-highlight.util.js